import types from './types';
import {dispatchAsync} from 'redux/common';
import api from 'api';
import ApiService from 'api/ApiService';
import {DialogCallbacks} from 'types/common';

const moveFolder = (folderIds: string[], parentFolderId: string, cbs?: DialogCallbacks) =>
   dispatchAsync(api.folderMove, types.MOVE_SUB_FOLDER, {
      ...cbs,
      getMethod: ApiService.postSecureJson,
      data: {
         parentFolderId,
         folderId: folderIds[0],
      },
   });

export default {
   moveFolder,
};
